<template>
  <div>
    <div v-if="showIntroduction">
      <h1>Welcome to retribute</h1>
      <p class="flow-text">
        Retribute gives you an easy and convenient way to support your favorite creators.
      </p>
      <h2>How does it work?</h2>
      <ol class="flow-text">
        <li>Connect Retribute to one or many of your existing Mastodon accounts</li>
        <li>Retribute will suggest you creators to tip, with links to their donation platforms</li>
      </ol>
      <router-link to="/connect" class="waves-effect waves-light btn-large">Get started</router-link>
    </div>
    <suggestions v-else></suggestions>
  </div>
</template>

<script>
import Suggestions from '@/components/Suggestions'

export default {
  components: {
    Suggestions
  },
  computed: {
    showIntroduction () {
      return this.$store.getters.sortedAccounts.length === 0
    }
  }
}
</script>
